import React, {createContext, useReducer, useMemo} from "react";

let LayoutContext = createContext();

let initialState = {
  openNuevaVenta: false,
  tipoNuevaVenta: null,
  libro: null,
  openCargaArchivoVenta: false,
  openModalUsuario: false,
  openModalEmpresas:false,
  datosEmpresa: null,
  estadisticasEmpresa:[],
  listadoEmpresas:[],
  dtesLibro: [],
  //ACA SE ESTAN GUARDANDO LOS DATOS GENERICOS
  tiposDoc: [],
  impuestosAdicionales: [],
  regiones: [],
  actividades: [],
  dteData: null,
  cambioDte: [],
  cambioRcv: [],
  tags:[],
  nuevoDte: {emitidos:0,recibidos:0},
  Alert: {
    Accion:()=>{},
    abrir:false,
    titulo:"",
    contenido:"",
    botonAccion:"",
    sinAccion:false
  }
};

let reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initialState;
    case "tagsListado":
      return { ...state, tags: action.tags };
    case "toggleNuevaVenta":
      return { ...state, openNuevaVenta: !state.openNuevaVenta, tipoNuevaVenta:action.tipo };
    case "toggleLibro":
      return { ...state, libro: action.libro };
    case "agregaDteLibro":
      return { ...state, dtesLibro: action.dtesLibro };
    case "toggleModalUsuario":
      return { ...state, openModalUsuario: !state.openModalUsuario };
    case "toggleModalEmpresas":
      return { ...state, openModalEmpresas: !state.openModalEmpresas };
    case "setListadoEmpresas":
      return { ...state, listadoEmpresas: action.listado };
    case "toggleCargaArchivoVenta":
      return { ...state, openCargaArchivoVenta: !state.openCargaArchivoVenta };
    case "setTiposDoc":
      return { ...state, tiposDoc: action.tiposDoc };
    case "setDatosEmpresa":
      return { ...state, datosEmpresa: action.datosEmpresa };
    case "setImpuestosAdicionales":
      return { ...state, impuestosAdicionales: action.impuestosAdicionales };
    case "setEstadisticasEmpresa":
      return { ...state, estadisticasEmpresa: action.estadisticas };
    case "setRegiones":
      return { ...state, regiones: action.regiones };
    case "setActividades":
      return { ...state, actividades: action.actividades };
    case "setDteData":
      return { ...state, dteData: action.dteData };
    case "actualizaDte":
      return { ...state, cambioDte: action.datos};
    case "actualizaRcv":
      return { ...state, cambioRcv: action.datos};
    case "actualizaDteNuevo":
      return {
        ...state,
        nuevoDte: {
          ...state.nuevoDte,
          emitidos: action.tipo ? state.nuevoDte.emitidos + action.cant : state.nuevoDte.emitidos,
          recibidos: !action.tipo ? state.nuevoDte.recibidos + action.cant : state.nuevoDte.recibidos
        }
      };
    case "setAlert":
      if((action.Alert||{}).sinAccion){
        return { ...state, Alert: {...action.Alert,Accion:()=>{},abrir:true} };
      }else{
        return { ...state, Alert: {...action.Alert,abrir:true} };
      }
    case "resetAlert":
      return { ...state, Alert:{...state.Alert,abrir:false} };
    default:
      return state;
  }
};

function LayoutProvider(props) {
  let [state, dispatch] = useReducer(reducer, initialState);
  let value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <LayoutContext.Provider value={value}>{props.children}</LayoutContext.Provider>
  );
}

let LayoutConsumer = LayoutContext.Consumer;

const tdloaded = {}

export { LayoutContext, LayoutProvider, LayoutConsumer, tdloaded };